module.exports = __webpack_public_path__ + "img/90sheji_linggan_13171843@2x.b59ec76c.png";